var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container", class: { show: _vm.showModal } },
    [
      _c("div", { staticClass: "modal-overlay", on: { click: _vm.hide } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal shadow-xl",
          class: _vm.type,
          style: _vm.forcedSize,
        },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _vm._t("header"),
              _vm._v(" "),
              _c("i", {
                staticClass: "zmdi zmdi-close close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.hide($event)
                  },
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content", staticStyle: { overflow: "visible" } },
            [
              this.showModal || !this.resetContent
                ? _vm._t("content")
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }